import BaseService from "services/base";
import _ from "lodash";

class TransactionService extends BaseService {

      /**
     * sample query object
     */

      sampleQuery = () => {
    
        var query = {
            info: "", //search text name, barcode
            forders: ["folder_id_1"],//list forder
            items: ["item1"],//list forder
            quantity: {
                //filter quantity
                lte: 10,//less than or equa
                gte: 100,// greater than or equa
                exact: 100//exact quantity
            },
            time: {//low stock level
                lte: '2024-08-28',//less than or equa
                gte: '2024-08-29',// greater than or equa
       
            },
    
        }
    }



    /**
     * 
     * @param {refer sampleQuery} query 
     * @param {*} sort 
     * @param {*} option 
     * @returns 
     */
    list = async (query = {}, sort = {}, option = { group_item: false, paging: { page: 1, page_zize: 10 } }) => {
        var data = await this._api.post("transaction/list", { query, sort, option });
        return data;
    };



    




}

export default TransactionService;
